@use 'sass:math';
@use 'pkg:@ongov/ontario-design-system-global-styles/styles/scss/1-variables/global.variables' as globalVariables;
@use 'pkg:@ongov/ontario-design-system-global-styles/styles/scss/1-variables/spacing.variables' as spacing;
@use 'pkg:@ongov/ontario-design-system-global-styles/styles/scss/1-variables/colours.variables' as colours;
@use 'pkg:@ongov/ontario-design-system-global-styles/styles/scss/1-variables/breakpoints.variables' as breakpoints;
@use 'pkg:@ongov/ontario-design-system-global-styles/styles/scss/1-variables/fonts.variables' as fonts;
@use 'pkg:@ongov/ontario-design-system-global-styles/styles/scss/1-variables/z-index.variables' as zIndex;
@use 'pkg:@ongov/ontario-design-system-global-styles/styles/scss/1-variables/font-sizes.variables' as fontSizes;
@use 'pkg:@ongov/ontario-design-system-global-styles/styles/scss/1-variables/line-heights.variables' as lineheight;
@use 'pkg:@ongov/ontario-design-system-global-styles/styles/scss/1-variables/font-weights.variables' as fontWeights;
@use 'pkg:@ongov/ontario-design-system-global-styles/styles/scss/2-tools/placeholder/focus.placeholders' as placeholders;
@use 'pkg:@ongov/ontario-design-system-global-styles/styles/scss/4-elements/global.elements';
@use 'pkg:@ongov/ontario-design-system-global-styles/styles/scss/7-overrides/visibility.overrides';

@use '../../styles/fieldsets.scss';
@use '../../styles/labels.scss';
@use '../../styles/text-inputs.scss';
@forward '../../utils/components/error-message/error-message';

$ontario-radios-size: 32px;
$ontario-radios-size-mobile: 36px;
$ontario-input-offset: math.div((globalVariables.$touch-target-size - $ontario-radios-size), 2);

.ontario-radios {
	padding: spacing.$spacing-0 spacing.$spacing-0 spacing.$spacing-0 math.div(spacing.$spacing-1, 2);
	max-width: globalVariables.$standard-width;
}

.ontario-radios__item {
	position: relative;
	display: block;
	margin: spacing.$spacing-0 spacing.$spacing-0 spacing.$spacing-4;
	padding: spacing.$spacing-0 spacing.$spacing-6 spacing.$spacing-0;

	&:last-of-type {
		margin-bottom: spacing.$spacing-0;
	}

	.ontario-radios__hint-expander {
		margin: spacing.$spacing-3 spacing.$spacing-0 spacing.$spacing-0 spacing.$spacing-2;

		@media screen and (max-width: breakpoints.$small-breakpoint) {
			margin-top: spacing.$spacing-4;
		}
	}
}

.ontario-radios__input {
	cursor: pointer;
	margin: spacing.$spacing-0;
	position: absolute;
	opacity: 0;
	top: $ontario-input-offset * -1;
	left: $ontario-input-offset * -1;
	width: globalVariables.$touch-target-size;
	height: globalVariables.$touch-target-size;
	z-index: zIndex.$ontario-z-index-neutral;

	@media screen and (max-width: breakpoints.$small-breakpoint) {
		width: globalVariables.$touch-target-size-mobile;
		height: globalVariables.$touch-target-size-mobile;
		top: $ontario-input-offset * -0.75;
		left: $ontario-input-offset * -0.75;
	}
}

.ontario-radios__label {
	cursor: pointer;
	color: colours.$ontario-colour-black;
	display: inline-block;
	font-family: fonts.$ontario-font-raleway-modified;
	font-size: fontSizes.$ontario-font-size-standard-body-text;
	font-weight: fontWeights.$ontario-font-weights-bold;
	line-height: globalVariables.$line-height-default;
	// Specific spacing required in order to visually align label with input
	margin: 0.2rem 0;
	max-width: globalVariables.$narrow-width;
	padding: spacing.$spacing-0 spacing.$spacing-3;
	// remove 300ms pause on mobile
	touch-action: manipulation;
	white-space: normal;
	width: auto;
	white-space: normal;

	@media screen and (max-width: breakpoints.$small-breakpoint) {
		// Specific spacing required in order to visually align label with input
		margin: 0.3rem spacing.$spacing-0;
		padding: spacing.$spacing-0 spacing.$spacing-4;
	}

	&:before {
		content: '';
		border: globalVariables.$border-size-standard solid colours.$ontario-colour-black;
		background-color: colours.$ontario-colour-white;
		border-radius: 50%;
		box-sizing: border-box;
		position: absolute;
		top: 0;
		left: 0;
		width: $ontario-radios-size;
		height: $ontario-radios-size;
		transition: border 0.1s ease-in-out;

		@media screen and (max-width: breakpoints.$small-breakpoint) {
			width: $ontario-radios-size-mobile;
			height: $ontario-radios-size-mobile;
		}
	}

	&:after {
		content: '';
		border-radius: 50%;
		border: 10px solid colours.$ontario-colour-black;
		position: absolute;
		top: 0;
		left: 0;
		transform: translate($ontario-input-offset * 3, $ontario-input-offset * 3);
		opacity: 0;

		@media screen and (max-width: breakpoints.$small-breakpoint) {
			border: 12px solid colours.$ontario-colour-black;
		}
	}
}

.ontario-radios__input:focus + .ontario-radios__label:before {
	-moz-box-shadow: placeholders.$ontario-focus-box-shadow;
	-webkit-box-shadow: colours.$ontario-colour-focus;
	@extend %ontario-focus;
}

.ontario-radios__input:checked + .ontario-radios__label:after {
	opacity: 1;
}

.ontario-radios__hint-expander {
	margin: spacing.$spacing-3 spacing.$spacing-0 spacing.$spacing-0 spacing.$spacing-0;

	@media screen and (max-width: breakpoints.$small-breakpoint) {
		margin-top: spacing.$spacing-4;
	}
}
